module.exports = __webpack_public_path__ + "static/media/blog-6.2bcc8093.jpg";